/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Tue, Aug 3rd 2021, 2:34:24 pm
 *
 * *****************************************************
 */

import styled from 'styled-components';

export const Button = styled.button`
  position: absolute;
  top: 2.4rem;
  left: 3rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: 1.2rem !important;

  svg {
    width: 2rem;
    height: 2rem;
  }

  cursor: pointer;

  @media (max-width: 35em) {
    left: 0.8rem;
  }

  /* OVERRIDEN CSS */
  background-color: transparent;
  border: none;
  box-shadow: none;
`;
